<template>
  <aside class="sidebar">
    <div class="sidebar-header d-flex align-items-center" style="padding-left: 1.8rem; padding-top: 2rem; padding-bottom: 1rem;">
      <img src="@lib/frontend/assets/logo.png" alt="Time Change Logo" style="max-width: 100%; height: 35px; object-fit: contain;" />
    </div>

    <div class="sidebar-menu mt-4">
      <!-- Admin/Authenticated Links -->
      <template v-if="profile && profile.role && profile.role.name === 'Authenticated'">
        <router-link to="/shipcalls" class="nav-item" active-class="active">
          <i class="fa fa-ship nav-icon"></i> Ship Calls
        </router-link>
        <router-link to="/register" class="nav-item" active-class="active">
          <i class="fa fa-file-signature nav-icon"></i> Create Ship Call
        </router-link>
        <router-link to="/locations" class="nav-item" active-class="active">
          <i class="fa fa-map-marker-alt nav-icon"></i> Locations
        </router-link>
        <router-link to="/restaurant" class="nav-item" active-class="active">
          <i class="fa fa-utensils nav-icon"></i> Restaurants
        </router-link>
        <router-link to="/template" class="nav-item" active-class="active">
          <i class="fa fa-file-alt nav-icon"></i> Templates
        </router-link>
        <router-link to="/cruiselines" class="nav-item" active-class="active">
          <i class="fa fa-anchor nav-icon"></i> Cruiselines
        </router-link>
        <router-link to="/survey-management" class="nav-item" active-class="active">
          <i class="fa fa-poll nav-icon"></i> Surveys
        </router-link>
      </template>

      <!-- Host Links -->
      <template v-if="profile && profile.role && profile.role.name === 'Host'">
        <router-link to="/survey-management" class="nav-item" active-class="active">
          <i class="fa fa-poll nav-icon"></i> Surveys
        </router-link>
      </template>
    </div>

    <div class="sidebar-footer mt-auto p-4 border-top border-secondary">
      <div v-if="profile" class="user-profile mb-3 text-white small opacity-75">
        <i class="fa fa-user-circle me-2"></i> {{ profile.email }}
      </div>
      <button v-if="profile" @click="logout" class="btn btn-outline-light w-100 border-0 text-start px-3 py-2 rounded-3 text-muted logout-btn">
        <i class="fa fa-sign-out-alt me-2 text-danger"></i> Sign Out
      </button>
      <router-link v-else :to="{ name: 'login' }" class="btn btn-primary-gradient w-100 rounded-pill">
        Login
      </router-link>
    </div>
  </aside>
</template>

<script setup>
import { inject } from 'vue'
const { profile, logout } = inject('user')
</script>

<style scoped>
.sidebar {
  width: 260px;
  background-color: #11142D;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  z-index: 1000;
  box-shadow: 2px 0 10px rgba(0,0,0,0.1);
  overflow-y: auto;
}

.sidebar-header {
  padding: 2rem 1.5rem;
}

.logo-icon {
  width: 32px;
  height: 32px;
  background: rgba(255,255,255,0.1);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

.text-gradient {
  background: linear-gradient(135deg, #a594ff, #8a7df0);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.sidebar-menu {
  flex: 1;
  padding: 0 1rem;
}

.nav-item {
  display: flex;
  align-items: center;
  padding: 0.8rem 1rem;
  color: #B2B2BF;
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 500;
  border-radius: 12px;
  margin-bottom: 0.5rem;
  transition: all 0.2s ease;
}

.nav-item:hover {
  background-color: rgba(255,255,255,0.05);
  color: #ffffff;
}

.nav-item.active {
  background: linear-gradient(135deg, #6C5DD3, #8a7df0);
  color: #ffffff;
  box-shadow: 0 4px 15px rgba(108, 93, 211, 0.4);
}

.nav-icon {
  width: 24px;
  font-size: 1.1rem;
  margin-right: 12px;
  text-align: center;
  opacity: 0.7;
}

.nav-item.active .nav-icon {
  opacity: 1;
}

.border-secondary {
  border-color: rgba(255,255,255,0.1) !important;
}

.logout-btn:hover {
  background-color: rgba(255,255,255,0.05);
  color: #ffffff !important;
}

.btn-primary-gradient {
  background: #6C5DD3;
  border: none;
  color: white;
}

@media (max-width: 991px) {
  .sidebar {
    transform: translateX(-100%);
    transition: transform 0.3s;
  }
  .sidebar.mobile-open {
    transform: translateX(0);
  }
}
</style>
